<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="banner"></banner>
    <enterTitle></enterTitle>
    <div class="w80 mb-30 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection()"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
          <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <div class="mt-30">
              <div class="corporate_middle fdw">
                <div
                  class="middle_cont"
                  v-for="(item, index) in list"
                  :key="index"
                  @click="onDetail(item)"
                >
                  <div class="middle_cont_left">
                    <img :src="item.cover" alt="" />
                  </div>
                  <p class="mt-10 title_far">{{ item.title }}</p>
                  <div class="middle_text fdc">
                    <p>{{ item.createtime.substring(0, 10) }}</p>
                    <p>
                      <span>浏览数 : </span><span>{{ item.visitcount }}</span>
                    </p>
                  </div>
                </div>
              </div>
            <!--分页-->
            <Pagination
              v-show="total > 0"
              :total="total"
              :page.sync="listQuery.curPage"
              :limit.sync="listQuery.limit"
              @pageChange="pageChange"
            ></Pagination>
          </div>
          <div style="margin-top:20%;">
                <notList :notCode="notCode"></notList>
          </div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>
<script>
import{addCollection} from "@/api/coment"
import { delRelease, releaseLists, eidRelease } from "@/api/company";
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise";
import banner from "../../common/banner";
import contTitle from "../../common/contTitle";
import baseInfo from "@/components/companyintroCard";
import Pagination from "../../components/Pagination";
import enterTitle from "@/common/enterTitle.vue"
import { getToken } from "@/utils/auth";
import notList from '../../common/notList'

export default {
  components: {
    footCom,
    headEnterprise,
    banner,
    contTitle,
    baseInfo,
    Pagination,
    enterTitle,
    notList
  },
  data() {
    return {
      contTitle: "经典案例",
	  headTitle: "供需平台",
      banner: {
        title: "经典案例",
        isShow: false,
        isColor: true,
        type:'',
        usertype:'',
        companytype:'',
        bannerUrl:'',
      },
      obj:{},
      data: [
        {
          id: 1,
          label: "全部分类",
          children: [
            {
              id: 2,
              label: "阻火活塞",
            },
            {
              id: 3,
              label: "阻火圈",
            },
            {
              id: 4,
              label: "全封闭烟道止回阀",
            },
            {
              id: 5,
              label: "卫生间烟道止回阀",
            },
          ],
        },
      ],
      list: [],
      delId: "",
      listQuery: {
        curPage: 1,
        limit: 6,
      },
      total: 0, //总条数
      checkList: [],
      notCode:false
    };
  },
  created(){
    if(getToken()!= undefined){
      this.$store.dispatch("company/getBaseInfo");  
    }
    this.id = sessionStorage.getItem('corporateId');
    if(this.id){
      this.getList();
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        if (val.userId) {
          this.banner.bannerUrl = val.banner;
        }
      },
      immediate: true,
    },
  },

  methods: {
    //获取列表
    getList() {
      releaseLists({ ...this.listQuery, userid: this.id })
        .then((res) => {
          if (res.code == 0) {
            this.list = res.page.list;
            this.total = res.page.totalCount;
            this.list.length == 0 ? this.notCode = true : this.notCode = false ;
          }
        })
        .catch((err) => {});
    },
    onDetail(item){
      this.$router.push({
        path:'/corporate_case_detail',
        query:{id:item.id}
      })
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getList();
    },
   //收藏
    goCollection(){
      let params ={
        goodsId: this.id,
        goodsType: 7
      }
      addCollection(params).then((res)=>{
        if(res.code == 0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{})
    },
  },
};
</script>
<style scoped>
.el-aside {
  height: 930px;
}
.fwd{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.mt-30 {
  margin-top: 30px;
}
.corporate_top img {
  width: 65%;
  height: 286px;
}
.corporate_top div {
  height: 286px;
  background: #02b854;
  padding: 40px 30px;
  text-align: left;
}
.corporate_top div p:first-child {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
}
.corporate_top div p:nth-child(2) {
  margin-top: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  line-height: 24px;
}
.corporate_top div p:last-child {
  margin-top: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
}
.corporate_middle {
  margin-top: 15px;
}
.middle_cont {
  width: 30%;
  text-align: left;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-right: 20px;
}
.middle_cont_left{
  overflow: hidden;
}
.middle_cont img {
  width: 100%;
  height: 162px;
  transition: all 0.6s;
}
.middle_cont img:hover{
   transform: scale(1.2);
}
.middle_cont p:nth-child(1) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
.middle_text {
  margin-top: 15px;
}
.middle_text p:nth-child(1) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}
.middle_text p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}

.el-pagination {
  margin-top: 40px;
}
.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}
.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.saide_mater {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}

.title_far{
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/view/corporate/corporate_case_all.vue